export enum RouteEnum {
  RECENTS = '/recents',
  PROFILE = '/profile',
  TEAM = '/team',
  BILING = '/biling',
  DATASETS = '/datasets',
  WORKBENCH = '/workbench',
  CLAIM = '/claim',
  ONTOLOGY = '/ontology',
  MODELS = '/models',
  Apis = '/api',
  ADMIN = '/admin',
}

export enum RouteChildEnum {
  ONTOLOGY_CLASS = '/ontology/class',
  ONTOLOGY_CLASSIFICATION = '/ontology/classification',
  ONTOLOGY_SCENARIO = '/ontology/scenario',
  DATASETS_DATA = '/datasets/data',
  DATASETS_CLASS = '/datasets/class',
  DATASETS_CLASSIFICATION = '/datasets/classification',
  DATASETS_OVERVIEW = '/datasets/overview',
  MODELS_DETAIL = '/models/detail',
  GROUP_INFO = '/team/groupInfo',
  SEARCH_SCENARIO = '/datasets/searchScenario',
}

export enum RouteNameEnum {
  DATASET = 'Dataset',
  DATASET_LIST = 'DatasetList',
  DATASET_DATA = 'DatasetData',
  DATASET_DETAIL = 'DatasetDetail',
  DATASET_OVERVIEW = 'DatasetsOverview',
  DATASET_CLASS = 'DatasetClass',
  DATASET_CLASSIFICATION = 'DatasetsClassification',
  MODEL = 'Model',
  MODEL_LIST = 'ModelList',
  MODEL_DETAIL = 'ModelDetail',
  TEAM = 'Team',
  TEAM_PAGE = 'TeamPage',
  TEAM_GROUP_INFO = 'TeamGroupInfo',
  TASK = 'Task',
  TASK_LIST = 'TaskList',
  TASK_CREATE = 'TaskCreate',
  TASK_DETAIL = 'TaskDetail',
  TASK_COUNTDOWN = 'TaskCountdown',
  TASK_PERFORMANCE = 'TaskPerformance',
}
